import React, {MutableRefObject, RefObject, useCallback, useEffect, useRef} from 'react'
import {createPortal, findDOMNode} from 'react-dom'

import {EmojiOption} from "./option"
import Popover from "../../../../gd-popover/popover-v2"
import PopoverPosition from "../../../../gd-popover/popover-position"
import {PopoverAttachmentType} from "../../../../gd-popover/@const"
import PopoverMenuOption from "../../../../popover-menu/popover-menu/menu-option"
import VScroll from "../../../../scrolling/custom-v-scroll/v-scroll"

type Props = {
    anchorElementRef: MutableRefObject<HTMLElement | null>
    itemProps       : {
        selectedIndex           : number | null
        selectOptionAndCleanUp  : (option: EmojiOption) => void
        setHighlightedIndex     : (index: number) => void
        options                 : Array<EmojiOption>
    }
    matchingString: string | null
}

const debug = false
// const debug = "EmojiMenuComponent"

export default function EmojiMenuComponent (props:Props): JSX.Element | null {
    if (!props.anchorElementRef.current || !props.itemProps.options.length) return null

    const scrollRef: RefObject<VScroll> = useRef<VScroll>(null)

    const onClick = (index:number, option:EmojiOption) => {
        props.itemProps.setHighlightedIndex(index)
        props.itemProps.selectOptionAndCleanUp(option)
    }

    useEffect(()=>{
        debug && console.log(debug, 'useEffect', props.itemProps.selectedIndex)

        if (scrollRef.current) {
            const node = findDOMNode(scrollRef.current)
            if (node) {
                const element: any = (node as Element)?.querySelector("#option-{0}".f(props.itemProps.selectedIndex))
                if (element) scrollRef.current?.setScrollTop(element.offsetTop + element.clientHeight/2,true,250)
            }
        }
    }, [props.itemProps.selectedIndex])

    const onPopoverHide = useCallback(()=>{
        if (props.anchorElementRef.current) {
            gd.utils.Dom.removeClass(props.anchorElementRef.current,"visible")
        }
    }, [])

    if (props.anchorElementRef.current) {
        gd.utils.Dom.addClass(props.anchorElementRef.current,"visible")
    }

    if (!props.anchorElementRef.current || !props.itemProps.options.length) return null

    const popoverPosition = new PopoverPosition({
        attachment      : "bottom left",
        targetAttachment: "top left",
        attachmentType  : PopoverAttachmentType.HORIZONTAL,
    })

    return createPortal(
        <Popover position       = {popoverPosition}
                 onPopoverHide      = {onPopoverHide}
                 getTargetFunc      = {()=>props.anchorElementRef.current}>
            <VScroll ref={scrollRef} containerStyle={{maxHeight: 200}}>
                <div className="ui5-popover-menu icon-fs-16" style={{minWidth:180}}>
                    {_.map(props.itemProps.options, (option:EmojiOption, index:number) => (
                        <PopoverMenuOption key              = {index}
                                           id               = {"option-{0}".f(index)}
                                           option           = {option as any}
                                           iconComponent    = {option.iconComponent}
                                           isHighlighted    = {index === props.itemProps.selectedIndex}
                                           onClick          = {()=>onClick(index, option)}/>
                    ))}
                </div>
            </VScroll>
        </Popover>,
        props.anchorElementRef.current,
    )
}
